import cookie from 'js-cookie'

export const AUTH_TOKEN_COOKIE = 'eezy-cm-auth-token'

// Always a browser-session cookie. The 30 days lives in the httpOnly
// remember_user_token that Devise sets, which JS cannot read or forge. This cookie holds
// a JWT that JS can read, so it should not outlive the browser session.
export const setAuthToken = (token: string): void => {
  cookie.set(AUTH_TOKEN_COOKIE, token)
}

export const getAuthToken = (): string | undefined =>
  cookie.get(AUTH_TOKEN_COOKIE)

export const clearAuthToken = (): void => {
  cookie.remove(AUTH_TOKEN_COOKIE)
}
